/* globals jQuery, google */
(($) => {
    /* SETUP NEIGHBORHOOD MAP */
    var map = document.getElementById('neighborhood-map');
    if (map) {
        var NeighborhoodFeaturesMapClass = require('./community_features_map.js');
        var neighborhoodFeaturesMap = new NeighborhoodFeaturesMapClass(map);
        neighborhoodFeaturesMap.initMap(true);
    }

    //responsiveNav enqueued through common.js which is also on this page
    //neighborhood map embed filters toggle form mobile
    $('.neighborhood-filter-nav').responsiveNav({
		navType: 'dropdown',
		menuButtonSelector: '.neighborhood-map__filter-toggle',
		dropdownSelector: '.neighborhood-filters'
	});


})(jQuery)